<template>
  <div>
    <div v-show="status==='projectList'">
      <project-table ref="projectTable" :operateColumns="operateColumns" :extraQuery="extraQuery" :extraSearch="extraSearch"></project-table>
    </div>
    <div v-if="status==='allTypesFile'">
      <project-card :projectData="projectData" @back="backList"></project-card>
      <all-types-file :projectData="projectData"></all-types-file>
    </div>
    <div v-if="status==='reviewFile'">
      <project-card :projectData="projectData" @back="backList"></project-card>
      <review-file :projectData="projectData" @back="backList"></review-file>
    </div>
    <!-- 采购记录表 -->
    <Modal class="record-modal" v-model="cgRecordVisible" title="采购活动记录表" width="1000">
      <iframe :src="cgRecordUrl" style="width:100%;height:600px;"></iframe>
      <div slot="footer"></div>
    </Modal>
    <Modal title="审核详情" v-model="detailVisible">
      <div class="examine-wrapper">
        <template v-if="examineDetails.length > 0">
          <div class="examine-item" v-for="examine in examineList">
            <span style="margin-right:10px;"><span style="font-weight:bold">申请时间：</span>{{examine.applyTime}}</span>
            <span style="margin-right:10px;"><span style="font-weight:bold;">操作时间：</span>{{examine.rejectTime}}</span>
            <div>
              <span style="margin-right:10px;"><span style="font-weight:bold">操作人：</span>{{examine.rejectPerson}}</span>
              <span style="margin-right:10px;" v-if="examine.status"><span style="font-weight:bold">状态：</span>{{examine.status}}</span>
            </div>
            <div style="margin:5px 0 15px 0;">
              <span style="font-weight:bold">备注：</span>{{examine.rejectReason}}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="examine-item">
            <span style="margin-right:10px;">
              <span style="font-weight:bold">申请时间：</span>{{projectData.appStartTime | filterTime}}</span>
            <span style="margin-right:10px;" v-if="projectData.appPassTime">
              <span style="font-weight:bold">操作时间：</span>{{projectData.appPassTime | filterTime}}</span>
            <div style="margin:5px 0 15px 0;">
              <span style="font-weight:bold">状态：</span>{{projectData.endStatusName}}
            </div>
          </div>
        </template>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ProjectTable from '@/components/projectTable'
import AllTypesFile from './allTypesFile'
import ReviewFile from './reviewFile'
import ProjectCard from '@/views/documentation/projectCard'
import ajax from '@/lib/ajax'
import x2js from "x2js"
import { getProjectPermission } from "@/lib/projectPermission"
import requestUrls from '@/lib/requestUrls'

export default {
  name: 'documentSummary',
  components: {
    ProjectTable,
    AllTypesFile,
    ProjectCard,
    ReviewFile
  },
  data() {
    return {
      operateColumns: [
        {
          title: '客户经理',
          key: 'am',
          width: 85,
        },
        {
          title: '审核状态',
          width: 85,
          render: (h, params) => {
            if (!params.row.endStatusCode) {
              return h('div', '未发起')
            } else {
              let state = {
                '1': '申请中',
                '2': '通过',
                '3': '不通过'
              }
              return h('div', state[params.row.endStatusCode])
            }
          }
        },
        {
          title: '审核详情',
          width: 85,
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'success',
                size: 'small'
              },
              on: {
                click: () => {
                  this.projectData = params.row

                  this.examineDetails = []
                  const x2Json = new x2js()
                  if (this.projectData.endStatusName && this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
                    this.examineDetails = x2Json.xml2js(this.projectData.endStatusName).recordList.record
                  }

                  this.detailVisible = true
                }
              }
            }, '审核详情')
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 250,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px'
                  },
                  on: {
                    click: () => {
                      this.cgRecordUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d28%5D%5B63a7%5D%5B62a5%5D%5B8868%5D%2F%5B91c7%5D%5B8d2d%5D%5B6d3b%5D%5B52a8%5D%5B8bb0%5D%5B5f55%5D%5B8868%5D.cpt&Id=${params.row.id}`
                      this.cgRecordVisible = true
                    }
                  }
                }, '采购记录表'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      // 限制进入4.0立项
                      if (this.projectData.dataSource === '4.0立项') {
                        this.$Modal.confirm({
                          title: '温馨提示',
                          content: '汇总文件及结项申请功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
                          cancelText: '取消',
                          okText: '立即前往',
                          onOk: () => {
                            if (isWeiXin()) {
                              window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                            } else {
                              window.open('https://qy.choicelink.cn:8440')
                            }
                          }
                        })
                        return
                      }
                      // this.projectData = params.row
                      this.status = 'allTypesFile'
                    }
                  }
                }, '汇总文件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginTop: '5px',
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.status = 'reviewFile'
                    }
                  }
                }, '评审文件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px',
                    marginBottom: '5px'
                  },
                  on: {
                    click: () => {

                    }
                  }
                }, '二维码文件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px',
                    marginBottom: '5px'
                  },
                  on: {
                    click: () => {

                    }
                  }
                }, '录像文件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginTop: '5px',
                    marginBottom: '5px'
                  },
                  on: {
                    click: () => {

                    }
                  }
                }, '过程文件'),
              ])
          }
        }
      ],
      extraQuery: {
        status: ' and (projectState == "已开评标完" or projectState == "项目失败")',
        rolePermission: ''
      },
      extraSearch: {
        searchEndTime: true,
        searchManager: true
      },
      status: 'projectList',
      projectData: {},
      cgRecordVisible: false,
      cgRecordUrl: '',
      detailVisible: false,
      examineDetails: []
    }
  },
  computed: {
    examineList() {
      return this.examineDetails.slice(1)
    }
  },
  methods: {
    backList() {
      this.status = 'projectList'
      this.$refs.projectTable.refreshProject()
    }
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'documentSummary' && this.status === 'projectList') {
        this.$refs.projectTable.refreshProject()
      }
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      return val.replace('T', ' ').split('.')[0]
    }
  }
}
</script>

<style lang="less">
.record-modal {
  .ivu-modal {
    top: 30px;
  }
}
</style>
